import { useRef } from 'react';

export const useSyncedRef = <T>(val: T) => {
    const ref = useRef(val);
    ref.current = val;
    return ref;
};
